<template>
  <Teleport to="body">
    <transition name="modal-fade">
      <div v-if="isVisible" class="modal-overlay-v2" @click.self="close">
        <div class="modal-content-glass">
            <!-- Renderiza todo o conteúdo dentro do Slot para que o HTML do filho defina Headers/Footers -->
            <slot></slot>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    isVisible: { type: Boolean, required: true }
  },
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
/* V2 Modal Aesthetics */
.modal-overlay-v2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10050; /* Supera elementos de layout */
  background-color: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(8px); /* Efeito Glassmorphism corporativo Apple */
  -webkit-backdrop-filter: blur(8px);

  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content-glass {
  background-color: #FFFFFF;
  padding: 2rem;
  border-radius: 16px;
  width: 90%;
  max-width: 650px;
  max-height: 90vh; /* Impede que modal seja maior que a tela */
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;

  /* Barra de scroll macia interna */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #CBD5E1;
    border-radius: 10px;
  }
}

/* Transições Suaves V2 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px) scale(0.98);
}
</style>
